import React from "react";
import LongShortChart from "../Charts/LongShortChart";
import LongShortWithTabs from "../Charts/LongShortWithTabs";

const ResultByDaysChart = ({ data }) => {
  const labels = data && Object.keys(data); // ['Friday', 'Monday', 'Sunday', 'Tuesday']

  const seriesData = [
    {
      name: "Open",
      data:
        (labels && labels?.map((day) => Number(data[day]?.open)?.toFixed(2))) ||
        [], // [ -2074.12, 49, 328.45, 494.83 ]
    },
    {
      name: "Close",
      data:
        (labels &&
          labels?.map((day) => Number(data[day]?.close)?.toFixed(2))) ||
        [], // [ 371.93, 1683.34, 17.4, 3005.19 ]
    },
  ];

  console.log("ResultByDaysChart", seriesData[0]?.data);

  return (
    <>
      <div className="ResultByDaysChart">
        <div className="ResultByDaysChart_left">
          <LongShortWithTabs
            labels={labels}
            seriesData={seriesData[0]?.data}
            name={seriesData[0]?.name}
          />
        </div>
        <div className="ResultByDaysChart_right">
          <LongShortWithTabs
            labels={labels}
            seriesData={seriesData[1]?.data}
            name={seriesData[1]?.name}
          />
        </div>
      </div>
    </>
  );
};

export default ResultByDaysChart;
